import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  setSecondSidebarOpen,
  setSidebarOpen,
  setSidebarActiveTab,
} from '../actions/App';

import { APIupdateUserSettingValue } from '../api/User';

import { getSetting } from '../helpers/Settings';

const SidebarCollapseButton = ({
  profile,
  secondSidebarOpen,
  setOpen,
  setFiltersOpen,
  setSidebarTab,
}) => {
  const intl = useIntl();

  const handleSwitchSidebar = () => {
    if (secondSidebarOpen) {
      setFiltersOpen(false);
      setSidebarTab('1');
    }
    setOpen(!secondSidebarOpen);
    APIupdateUserSettingValue(profile.uuid, 'sidebar_open', !secondSidebarOpen);
  };

  if (getSetting('hide_collapsable_sidebar')) {
    if (!secondSidebarOpen) {
      setOpen(true);
    }
    return null;
  }

  return (
    <>
      <Button
        id="switch-sidebar"
        color="link"
        className="btn-link-common switch-second-sidebar-button"
        onClick={handleSwitchSidebar}
        size="md"
        aria-label={secondSidebarOpen ? intl.formatMessage({ defaultMessage: 'Hide sidebar' }) : intl.formatMessage({ defaultMessage: 'Show sidebar' })}
      >
        {secondSidebarOpen ? <i className="fal fa-chevrons-left" /> : <i className="fal fa-chevrons-right" /> }
      </Button>
      <UncontrolledTooltip fade={false} placement="bottom" target="switch-sidebar">
        {secondSidebarOpen ? (
          intl.formatMessage({ defaultMessage: 'Hide sidebar' })
        ) : (
          intl.formatMessage({ defaultMessage: 'Show sidebar' })
        )}
      </UncontrolledTooltip>
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  secondSidebarOpen: state.App.secondSidebarOpen,
});

const mapDispatchToProps = (dispatch) => ({
  setOpen: (open) => {
    dispatch(setSecondSidebarOpen(open));
  },
  setFiltersOpen: (open) => {
    dispatch(setSidebarOpen(open));
  },
  setSidebarTab: (tab) => {
    dispatch(setSidebarActiveTab(tab));
  },
});

SidebarCollapseButton.propTypes = {
  setOpen: PropTypes.func.isRequired,
  setFiltersOpen: PropTypes.func.isRequired,
  setSidebarTab: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  secondSidebarOpen: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarCollapseButton);
